export default {"src":"/_next/static/media/plausible.4cdf0350.svg","height":1000,"width":1000,"blurWidth":0,"blurHeight":0};